import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';
import { SideNavComponent } from '../../shared/side-nav/side-nav.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';
import { Router } from '@angular/router';
import { AuthGuard } from '../../core/guard/auth.guard';
import { environment } from '../../../environments/environment';



interface USAData {
  USA: {
    states: {
      [state: string]: string[];
    };
  };
}


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrl: './report.component.css'
})

export class ReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('content') content: any;
  currentStep: number = 0;
  isSideNavOpened: boolean = false;
  form!: FormGroup;
  steps: any[] = [];
  isLoading: boolean = false;
  isDesktop: boolean = false;
  currentHeading: string = 'Accident Information/Vehicle 1';
  @ViewChild('report') report!: ElementRef;
  isMobile: boolean = false;
  maxDate: string = '';
  private scrollListener: (() => void) | undefined;
  yearList: number[] = [];
  isDropdownOpen = false; // Tracks dropdown state
  locationData: any;
  // states: string[] = [];
  states: { name: string; code: string }[] = [];
  allcities: string[] = [];
  cityMap: { [key: string]: any[] } = {
    cities: [],
    sec4P1Cities: [],
    sec4P2Cities: [],
    sec4PropOwnCities: [],
    sec4W1Cities: [],
    sec4W2Cities: []
  }
  countyMap: { [key: string]: any[] } = {
    counties: [],
  }
  // injuryMap: { [key: string]: any } = {
  //   P1InjuryType:[],
  //   P2InjuryType:[]
  // }
  zipCodes: string[] = [];
  selected = -1;
  isOtherAccTypeSelected: boolean = false;
  vehicleState = [{ label: 'Moving', value: 'M1S0' }, { label: 'Stopped in Traffic', value: 'M0S1' }];
  involvedINAccidentType = [{ label: 'Pedestrain', value: 'P1S0O0' }, { label: 'Bicyclist', value: 'P0S1O0' }, { label: 'Other', value: 'P0S0O1' }];
  vehicleDamageType = [{ label: 'UNK', value: 'UK1NO0MI0MD0MJ0' }, { label: 'NONE', value: 'UK0NO1MI0MD0MJ0' }, { label: 'MINOR', value: 'UK0NO0MI1MD0MJ0' }, { label: 'MOD', value: 'UK0NO0MI0MD1MJ0' }, { label: 'MAJOR', value: 'UK0NO0MI0MD0MJ1' }];
  P1InjuryType = [{ label: 'Injured', checkedTrue: 'IN1', checkedFalse: 'IN0', isChecked: false }, { label: 'Deceased', checkedTrue: 'DE1', checkedFalse: 'DE0', isChecked: false }, { label: 'Driver', checkedTrue: 'DR1', checkedFalse: 'DR0', isChecked: false }, { label: 'Passenger', checkedTrue: 'PA1', checkedFalse: 'PA0', isChecked: false }, { label: 'Bicyclist', checkedTrue: 'BI1', checkedFalse: 'BI0', isChecked: false }, { label: 'Property', checkedTrue: 'PR1', checkedFalse: 'PR0', isChecked: false }];
  P2InjuryType = [{ label: 'Injured', checkedTrue: 'IN1', checkedFalse: 'IN0', isChecked: false }, { label: 'Deceased', checkedTrue: 'DE1', checkedFalse: 'DE0', isChecked: false }, { label: 'Driver', checkedTrue: 'DR1', checkedFalse: 'DR0', isChecked: false }, { label: 'Passenger', checkedTrue: 'PA1', checkedFalse: 'PA0', isChecked: false }, { label: 'Bicyclist', checkedTrue: 'BI1', checkedFalse: 'BI0', isChecked: false }, { label: 'Property', checkedTrue: 'PR1', checkedFalse: 'PR0', isChecked: false }];
  formattedP1InjuryType: string = 'test';
  [key: string]: any;
  //  [key: string]: any;: This is an index signature. It tells TypeScript that the ReportComponent class can have any properties with string keys, and the value of those properties can be of any type (any in this case). This allows this[name] to work without raising errors, because TypeScript now knows that this[name] can be any property of the class, even if it isn't explicitly declared in the class.
  private hourTimerSubscription!: Subscription;
  private modalTimerSubscription!: Subscription;
  showModal = false;
  modalCountdown = 20; // 20 seconds for the modal timer
  // rows = Array(10).fill(0); // Adjust rows
  // cols = Array(8).fill(0); // Adjust columns
  carStructure = [
    [0, 14, 2, 2, 2, 2, 6, 0], // Front row
    [4, 1, 1, 1, 1, 1, 12, 5], // Second row
    // [4, 0,0,0,0,0,0, 5], // Third row
    [4, 1, 1, 1, 1, 1, 13, 5], // Fourth row
    [15, 1, 3, 3, 3, 3, 3, 9], // Fifth row
  ];

  carStructure2 = [
    [{ label: 'C1R1', cellValue: 0, checkedTrue: 'C1R11', checkedFalse: 'C1R10', isChecked: false }, { label: 'C2R1', cellValue: 14, checkedTrue: 'C2R11', checkedFalse: 'C2R10', isChecked: false }, { label: 'C3R1', cellValue: 2, checkedTrue: 'C3R11', checkedFalse: 'C3R10', isChecked: false }, { label: 'C4R1', cellValue: 2, checkedTrue: 'C4R11', checkedFalse: 'C4R10', isChecked: false }, { label: 'C5R1', cellValue: 2, checkedTrue: 'C5R11', checkedFalse: 'C5R10', isChecked: false }, { label: 'C6R1', cellValue: 2, checkedTrue: 'C6R11', checkedFalse: 'C6R10', isChecked: false }, { label: 'C7R1', cellValue: 6, checkedTrue: 'C7R11', checkedFalse: 'C7R10', isChecked: false }, { label: 'C8R1', cellValue: 0, checkedTrue: 'C8R11', checkedFalse: 'C8R10', isChecked: false }],
    [{ label: 'C1R2', cellValue: 4, checkedTrue: 'C1R21', checkedFalse: 'C1R20', isChecked: false }, { label: 'C2R2', cellValue: 1, checkedTrue: 'C2R21', checkedFalse: 'C2R20', isChecked: false }, { label: 'C3R2', cellValue: 1, checkedTrue: 'C3R21', checkedFalse: 'C3R20', isChecked: false }, { label: 'C4R2', cellValue: 1, checkedTrue: 'C4R11', checkedFalse: 'C4R20', isChecked: false }, { label: 'C5R2', cellValue: 1, checkedTrue: 'C5R21', checkedFalse: 'C5R20', isChecked: false }, { label: 'C6R2', cellValue: 1, checkedTrue: 'C6R21', checkedFalse: 'C6R20', isChecked: false }, { label: 'C7R2', cellValue: 12, checkedTrue: 'C7R21', checkedFalse: 'C7R20', isChecked: false }, { label: 'C8R2', cellValue: 5, checkedTrue: 'C8R21', checkedFalse: 'C8R20', isChecked: false }],
    [{ label: 'C1R3', cellValue: 4, checkedTrue: 'C1R31', checkedFalse: 'C1R30', isChecked: false }, { label: 'C2R3', cellValue: 1, checkedTrue: 'C2R31', checkedFalse: 'C2R30', isChecked: false }, { label: 'C3R3', cellValue: 1, checkedTrue: 'C3R31', checkedFalse: 'C3R30', isChecked: false }, { label: 'C4R3', cellValue: 1, checkedTrue: 'C4R11', checkedFalse: 'C4R30', isChecked: false }, { label: 'C5R3', cellValue: 1, checkedTrue: 'C5R31', checkedFalse: 'C5R30', isChecked: false }, { label: 'C6R3', cellValue: 1, checkedTrue: 'C6R31', checkedFalse: 'C6R30', isChecked: false }, { label: 'C7R3', cellValue: 13, checkedTrue: 'C7R31', checkedFalse: 'C7R30', isChecked: false }, { label: 'C8R3', cellValue: 5, checkedTrue: 'C8R31', checkedFalse: 'C8R30', isChecked: false }],
    [{ label: 'C1R4', cellValue: 15, checkedTrue: 'C1R41', checkedFalse: 'C1R40', isChecked: false }, { label: 'C2R4', cellValue: 1, checkedTrue: 'C2R41', checkedFalse: 'C2R40', isChecked: false }, { label: 'C3R4', cellValue: 3, checkedTrue: 'C3R41', checkedFalse: 'C3R40', isChecked: false }, { label: 'C4R4', cellValue: 3, checkedTrue: 'C4R11', checkedFalse: 'C4R40', isChecked: false }, { label: 'C5R4', cellValue: 3, checkedTrue: 'C5R41', checkedFalse: 'C5R40', isChecked: false }, { label: 'C6R4', cellValue: 3, checkedTrue: 'C6R41', checkedFalse: 'C6R40', isChecked: false }, { label: 'C7R4', cellValue: 3, checkedTrue: 'C7R41', checkedFalse: 'C7R40', isChecked: false }, { label: 'C8R4', cellValue: 9, checkedTrue: 'C8R41', checkedFalse: 'C8R40', isChecked: false }]
  ]
  displayedColumns: string[] = ['id', 'types', 'veh1', 'veh2'];
  displayedYNColumns: string[] = ['id', 'types', 'yes', 'no'];
  weatherString: string = '';
  lightingString: string = '';
  rsString: string = '';
  rcString: string = '';
  mvtString: string = '';
  tocString: string = '';
  otherString: string = '';
  isSubmitted = false;
  onSubmitErrorMessage: string = '';
  telephonePrefix = '+1 -';
  numberOfVehiclesInvolved: number[] = Array.from({ length: 10 }, (_, i) => i + 1);
  currentLength: number = 0; // Tracks current length of textarea
  currentColor: string = 'gray'; // Initial color for character counter
  ELEMENT_DATA1 = [
    { id: 'A', types: 'Clear', veh1: false, veh2: false },
    { id: 'B', types: 'Cloudy', veh1: false, veh2: false },
    { id: 'C', types: 'Raining', veh1: false, veh2: false },
    { id: 'D', types: 'Snowing', veh1: false, veh2: false },
    { id: 'E', types: 'Fog/Visibility', veh1: false, veh2: false },
    { id: 'F', types: 'Other', veh1: false, veh2: false },
    { id: 'G', types: 'Wind', veh1: false, veh2: false },
  ];
  ELEMENT_DATA2 = [
    { id: 'A', types: 'Day Light', veh1: false, veh2: false },
    { id: 'B', types: 'Dusk-Dawn', veh1: false, veh2: false },
    { id: 'C', types: 'Dark-Street Lights', veh1: false, veh2: false },
    { id: 'D', types: 'Dark-No Street Lights', veh1: false, veh2: false },
    { id: 'E', types: 'Dark - Street Lights Not Functioning', veh1: false, veh2: false }
  ];
  ELEMENT_DATA3 = [
    { id: 'A', types: 'Dry', veh1: false, veh2: false },
    { id: 'B', types: 'Wet', veh1: false, veh2: false },
    { id: 'C', types: 'Snowy-Icy', veh1: false, veh2: false },
    { id: 'D', types: 'Slippery (Muddy/Oily/etc)', veh1: false, veh2: false },
  ];
  ELEMENT_DATA4 = [
    { id: 'A', types: 'Holes, Deep Rut', veh1: false, veh2: false },
    { id: 'B', types: 'Loose Material On Roadway', veh1: false, veh2: false },
    { id: 'C', types: 'Obstruction On Roadway', veh1: false, veh2: false },
    { id: 'D', types: 'Construction Repair Zone', veh1: false, veh2: false },
    { id: 'E', types: 'Reduced Roadway Width', veh1: false, veh2: false },
    { id: 'F', types: 'Flooded', veh1: false, veh2: false },
    { id: 'G', types: 'Other', veh1: false, veh2: false },
    { id: 'H', types: 'No Usual Conditions', veh1: false, veh2: false },
  ];
  ELEMENT_DATA5 = [
    { id: 'A', types: 'Stopped', veh1: false, veh2: false },
    { id: 'B', types: 'Proceeding Straight', veh1: false, veh2: false },
    { id: 'C', types: 'Ran Off Road', veh1: false, veh2: false },
    { id: 'D', types: 'Making Right Turn', veh1: false, veh2: false },
    { id: 'E', types: 'Making Left Turn', veh1: false, veh2: false },
    { id: 'F', types: 'Making U Turn', veh1: false, veh2: false },
    { id: 'G', types: 'Backing', veh1: false, veh2: false },
    { id: 'H', types: 'Slowing/Stopping', veh1: false, veh2: false },
    { id: 'I', types: 'Passing Other Vehicle', veh1: false, veh2: false },
    { id: 'J', types: 'Changing Lanes', veh1: false, veh2: false },
    { id: 'K', types: 'Parking Manuever', veh1: false, veh2: false },
    { id: 'L', types: 'Entering Traffic', veh1: false, veh2: false },
    { id: 'M', types: 'Other Unsafe Turning', veh1: false, veh2: false },
    { id: 'N', types: 'Xing Into Opposing Lane', veh1: false, veh2: false },
    { id: 'O', types: 'Parked', veh1: false, veh2: false },
    { id: 'P', types: 'Merging', veh1: false, veh2: false },
    { id: 'Q', types: 'Travelling Wrong way', veh1: false, veh2: false },
    { id: 'R', types: 'Other', veh1: false, veh2: false },
  ];
  ELEMENT_DATA6 = [
    { id: 'A', types: 'Head On', veh1: false, veh2: false },
    { id: 'B', types: 'Side Swipe', veh1: false, veh2: false },
    { id: 'C', types: 'Rear End', veh1: false, veh2: false },
    { id: 'D', types: 'Broad Side', veh1: false, veh2: false },
    { id: 'E', types: 'Hit Object', veh1: false, veh2: false },
    { id: 'F', types: 'Over Turned', veh1: false, veh2: false },
    { id: 'G', types: 'Vehicle/Pedestrain', veh1: false, veh2: false },
    { id: 'H', types: 'Other', veh1: false, veh2: false },
  ];
  ELEMENT_DATA7 = [
    { id: 'A', types: 'CVC Sections Violated Cited', yes: false, no: false },
    { id: 'B', types: 'Vision Obscurement', yes: false, no: false },
    { id: 'C', types: 'InAttention', yes: false, no: false },
    { id: 'D', types: 'Stop & Go Traffic', yes: false, no: false },
    { id: 'E', types: 'Entering/Leaving Ramp', yes: false, no: false },
    { id: 'F', types: 'Previous Collision', yes: false, no: false },
    { id: 'G', types: 'UnFamiliar with Road', yes: false, no: false },
    { id: 'H', types: 'Defective With Equip', yes: false, no: false },
    { id: 'I', types: 'UnInvolved Vehicle', yes: false, no: false },
    { id: 'J', types: 'Other', yes: false, no: false },
    { id: 'K', types: 'None Apparent ', yes: false, no: false },
    { id: 'L', types: 'Runaway Vehicle', yes: false, no: false },
  ];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private fb: FormBuilder,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private route: Router,
    private authGuard: AuthGuard
    // private modalService:ModalSer
  ) {

    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];

    this.form = this.fb.group({
      I_DRDR_ID: '',
      I_ACDNT_ID: '',
      N_DRVR_NAME: '',
      section1: this.fb.group({
        date_of_accident: ['', Validators.required],
        time_zone: ['AM0PM0'],
        time_of_accident: ['', Validators.required],
        vehicle_year: [null, Validators.required],
        make: [''],
        model: [''],
        license_plate_number: [''],
        vehicle_number: [''],
        state_vechicle_registered: [''],
        address: [''],
        state: ['', Validators.required],
        county: ['', Validators.required],
        city: ['', Validators.required],
        zip_code: [''],
        vehicles_involved: [''],
        vehicle_state: ['M0S0'],
        accident_involved: ['P0S0O0'],
        other_type: [''],
        driver_name: [''],
        driver_license_number: [''],
        driver_state: [''],
        date_of_birth: ['', Validators.required],
        insurance_company: ['', Validators.required],
        policy_number: ['', Validators.required],
        naic_number: [''],
        policy_period_from: ['', Validators.required],
        policy_period_to: ['', Validators.required],
        DESC_VEH_DAM: ['UK0NO0MI0MD0MJ0']
      }),
      section2: this.fb.group({
        Shaded_Damage_Area: ['C1R20C1R30C1R40C2R10C2R20C2R30C2R40C3R10C3R20C3R30C3R40C4R10C4R20C4R30C4R40C5R10C5R20C5R30C5R40C6R10C6R20C6R30C6R40C7R10C7R20C7R30C7R40C8R20C8R30C8R40']
        // carShape: this.fb.group(controls)
      }),
      section3: this.fb.group({
        veh2_vehicle_year: [null],
        veh2_model: [''],
        veh2_license_plate_number: [''],
        veh2_vehicle_number: [''],
        veh2_state_vechicle_registered: [''],
        veh2_vehicles_involved: [''],
        veh2_vehicle_state: ['M0S0'],
        veh2_accident_involved: ['P0S0O0'],
        veh2_other_type: [''],
        veh2_driver_name: [''],
        veh2_driver_license_number: [''],
        veh2_driver_state: [''],
        veh2_date_of_birth: ['', Validators.required],
        veh2_insurance_company: ['', Validators.required],
        veh2_policy_number: ['', Validators.required],
        veh2_naic_number: [''],
        veh2_policy_period_from: ['', Validators.required],
        veh2_policy_period_to: ['', Validators.required],
        section3_additional_info: [0]
      }),
      section4: this.fb.group({
        sec4_person1_name: [''],
        sec4_person1_address: [''],
        sec4_person1_city: [''],
        sec4_person1_state: [''],
        sec4_person1_zipcode: [''],
        sec4_person1_injurytype: ['IN0DE0DR0PA0BI0PR0'],
        sec4_person2_name: [''],
        sec4_person2_address: [''],
        sec4_person2_city: [''],
        sec4_person2_state: [''],
        sec4_person2_zipcode: [''],
        sec4_person2_injurytype: ['IN0DE0DR0PA0BI0PR0'],
        sec4_property_damage: [''],
        sec4_property_owner_name: [''],
        sec4_property_owner_number: [this.telephonePrefix],
        sec4_property_owner_street_address: [''],
        sec4_property_owner_city: [''],
        sec4_property_owner_state: [''],
        sec4_property_owner_zipcode: [''],
        sec4_witness1_name: [''],
        sec4_witness1_number: [this.telephonePrefix],
        sec4_witness1_address: [''],
        sec4_witness1_city: [''],
        sec4_witness1_state: [''],
        sec4_witness1_zipcode: [''],
        sec4_witness2_name: [''],
        sec4_witness2_number: [this.telephonePrefix],
        sec4_witness2_address: [''],
        sec4_witness2_city: [''],
        sec4_witness2_state: [''],
        sec4_witness2_zipcode: [''],
        section4_additional_info: [0]
      }),
      section5: this.fb.group({
        auto_mode: [null],
        conv_mode: [null],
        desc: ['', [Validators.required]],
        weather: [''],
        lighting: [''],
        roadway_surface: [''],
        roadway_conditions: [''],
        movement: [''],
        type_of_collision: [''],
        other: [''],
        section5_additional_info: [0]
      }),
    });
  }

  ngOnInit() {
    this.form.get('I_DRDR_ID')?.setValue(this.authGuard.driver_ID);
    this.form.get('N_DRVR_NAME')?.setValue(this.breadcrumbService.getDriverName());
    this.checkScreenSize();
    this.startHourTimer();
    this.generateYearList();
    // Subscribe to steps and get the active index
    this.breadcrumbService.steps$.subscribe((steps) => {
      // this.currentStep = steps.findIndex((step) => step.active);
      this.steps = steps;
    });

    this.breadcrumbService.sideNav$.subscribe((value) => {
      if (value) {
        this.isSideNavOpened = true;
      }
    });

    this.breadcrumbService.activeStepIndex$.subscribe((index: any) => {
      // if(this.validateCurrentSection()){
      this.currentStep = index;
      // this.currentStep = 4;

      this.updateFormSection(index);
      // }
    })

    if (document.body.classList.contains('.breadcrumbs-container')) {
      const header = document.querySelector('.breadcrumbs-container');
      this.scrollListener = () => {

        // Check vertical scroll position
        if (window.scrollY) { // Change '10' to whatever threshold you want
          header?.classList.add('scrolled');
        } else {
          header?.classList.remove('scrolled');
        }
      };
      // Add the scroll event listener
      window.addEventListener('scroll', this.scrollListener);

    }
    else {
      console.log('else')
    }


    // populate state,city dropdowns
    // Fetch the JSON file dynamically
    // this.http.get<USAData>('assets/US-states-counties.json').subscribe((data) => {
    //   this.locationData = data; // Store the fetched data
    //    this.states = Object.keys(this.locationData); // Extract states
    // });

    // populate state,city dropdowns
    // Fetch the JSON file dynamically
    this.http.get<USAData>('assets/US-states-counties.json').subscribe((data) => {
      this.locationData = data; // Store the fetched data
      // Convert to array of objects [{ name: "California", code: "CA" }, ...]
      this.states = Object.keys(this.locationData).map(state => ({
        name: state,
        code: this.locationData[state].state_code
      }));
      // this.states = Object.keys(this.locationData); // Extract states
    });

    // Watch for changes in the state field for all the diff sections and update respective cities 
    this.initializeStateChangeHandler('section1.state', 'counties', 'cities', 'section1.county', 'section1.city');
    this.initializeStateChangeCityShowHandler('section4.sec4_person1_state', 'sec4P1Cities', 'sec4_person1_city');
    this.initializeStateChangeCityShowHandler('section4.sec4_person2_state', 'sec4P2Cities', 'sec4_person2_city');
    this.initializeStateChangeCityShowHandler('section4.sec4_property_owner_state', 'sec4PropOwnCities', 'sec4_property_owner_city');
    this.initializeStateChangeCityShowHandler('section4.sec4_witness1_state', 'sec4W1Cities', 'sec4_witness1_city');
    this.initializeStateChangeCityShowHandler('section4.sec4_witness2_state', 'sec4W2Cities', 'sec4_witness2_city');

    this.initializeCountyChangeHandler('section1.county', 'counties', 'cities', 'city');


    this.updateAllStrings();
  }

  enforcePrefix(event: any, formName: String): void {
    const control = this.form.get('section4.' + formName);
    let value = control?.value || ''; // Ensure value is not null/undefined

    // Convert value to string and enforce the prefix
    value = String(value);
    if (!value.startsWith(this.telephonePrefix)) {
      value = this.telephonePrefix + value.replace(this.telephonePrefix, ''); // Enforce the prefix
    }

    // Allow only numeric characters after the prefix
    const afterPrefix = value.replace(this.telephonePrefix, '');
    value = this.telephonePrefix + afterPrefix.replace(/[^0-9]/g, '').slice(0, 10); // Limit to maxDigits , Remove non-numeric characters

    // Update the control value
    control?.setValue(value, { emitEvent: false });
  }

  onKeyDown(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;

    // Prevent backspace or delete when cursor is within the prefix
    if (
      (event.key === 'Backspace' || event.key === 'Delete') &&
      inputElement.selectionStart !== null &&
      inputElement.selectionStart <= this.telephonePrefix.length
    ) {
      event.preventDefault();
    }
  }

  // Starts the 1-hour timer
  startHourTimer(): void {
    this.hourTimerSubscription = timer(3600000).subscribe(() => {
      this.showModal = true;
      this.startModalTimer();
    });
  }

  // Open the Bootstrap modal
  //  private openModal(): void {
  //   const modalElement = document.getElementById('confirmationModal'); // Modal template reference
  //   this.modalReference = this.modalService.open(modalElement, {
  //     backdrop: 'static',
  //     keyboard: false
  //   });
  //   this.startModalTimer();
  // }

  // Starts the 20-second modal timer
  startModalTimer(): void {
    const modalTimer = timer(0, 1000); // Emits every second
    this.modalTimerSubscription = modalTimer.subscribe((count) => {
      this.modalCountdown = 20 - count;

      if (this.modalCountdown <= 0) {
        this.modalTimerSubscription.unsubscribe();
        this.logout();
      }
    });
  }

  // Handle "Yes" button click in the modal
  onContinue(): void {
    this.showModal = false;
    this.modalTimerSubscription.unsubscribe();
    this.startHourTimer(); // Restart the 1-hour timer
  }

  // Handle "No" button click in the modal
  logout(): void {
    this.authGuard.authenticateUser(0);
    this.route.navigate(['/login']);
    this.showModal = false;
  }

  // Update character count and apply color dynamically
  updateCharacterCount(): void {
    const descValue = this.form.get('section5.desc')?.value;
    this.currentLength = descValue.length;

    // Change color based on character count thresholds
    if (this.currentLength >= 180) {
      this.currentColor = 'red'; // Near the maximum limit
    } else if (this.currentLength >= 150) {
      this.currentColor = 'orange'; // Approaching the limit
    } else {
      this.currentColor = 'gray'; // Safe zone
    }
  }


  onCheckboxChange(event: any, index: number, label: string, value: string, formSection: string, formControlName: string) {
    this[value].map((x: any) => {
      if ((x.label == label)) {
        x.isChecked = event.target.checked
      }
    })

    const formattedValue = this[value]
      .map((type: any) => (type.isChecked ? type.checkedTrue : type.checkedFalse))
      .join('');

    this.form.get(formSection + '.' + formControlName)?.setValue(formattedValue);
  }

  onShadedCheckBoxChange(event: any, rowIndex: number, colIndex: number, label: string, value: string, formSection: string, formControlName: string) {

    this[value].map((x: any) => {
      x.map((y: any) => {
        if ((y.label == label)) {
          y.isChecked = event.target.checked;
        }
      })
    })

    // const formattedValue = //row wise mapping
    //   this[value].map((x: any) =>
    //     x.map((y: any) =>
    //       y.isChecked ? y.checkedTrue : y.checkedFalse
    //     )).join(',');


    const formattedValue = this[value][0] // Access the first row to get column indices
      .map((_: any, colIndex: number) => // Loop through columns
        this[value] // Loop through all rows for each column
          .map((row: any) => {
            const cell = row[colIndex]; // Get the cell at the current column index
            //skip values for c1r1 and c8r1 since those are invinsible in  UI
            if (cell.label === 'C1R1' || cell.label === 'C8R1') {
              return '';
            }
            else {
              const value = cell.isChecked ? cell.checkedTrue : cell.checkedFalse; // Include either checkedTrue or checkedFalse
              return value;
            }
          })
          .join('') // Combine values within the column
      )
      .join(''); // Combine all column-wise values into the final string


    this.form.get(formSection + '.' + formControlName)?.setValue(formattedValue);

    this.form.get(formSection + '.' + formControlName)?.setValue(formattedValue);
  }

  ngAfterViewInit(): void {
    const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll('.form-control');

    inputs.forEach((input) => {
      input.addEventListener('focus', () => {
        const label = input.nextElementSibling as HTMLElement;
        if (label) {
          label.classList.add('active');
        }
      });

      input.addEventListener('blur', () => {
        const label = input.nextElementSibling as HTMLElement;
        if (label && !input.value) {
          label.classList.remove('active');
        }
      });
    });
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    window.opener.location.reload();
    this.currentStep = 0;
  }


  // strongly typed  Mapping of the counties to get the vales dynamicaly declared
  initializeStateChangeHandler(
    stateControlPath: string,
    countyKey: string,
    cityKey: string,
    countyControlPath: string,
    cityControlPath: string
  ) {
    this.form.get(stateControlPath)?.valueChanges.subscribe((state: string) => {

      if (state && this.locationData) {
        console.log(state, this.locationData)

        // Find the state name from locationData using state code
        const stateEntry = Object.entries(this.locationData).find(
          (data: any) => data[1].state_code === state
        );
        const stateName = stateEntry ? stateEntry[0] : null; // Get state name
        console.log(stateName, 'line ni 577');
        if (stateName && this.locationData[stateName]) {

          this.countyMap[countyKey] = this.locationData[stateName].counties; // Extract counties for the selected state
        }

      } else {
        this.countyMap[countyKey] = [];
        this.cityMap[cityKey] = [];
      }
      this.form.get(countyControlPath)?.reset(); // Reset county selection
      this.form.get(cityControlPath)?.reset(); // Reset city selection
    });

    console.log(this.countyMap, 'line no 566');
  }

  // strongly typed  Mapping of the cities to get the vales dynamicaly declared
  initializeCountyChangeHandler(
    CountyControlPath: string,
    countyKey: string,
    cityKey: string,
    cityControlPath: string
  ) {
    this.form.get(CountyControlPath)?.valueChanges.subscribe((county: string) => {
      if (county && this.locationData) {
        const slectedCountyData = this.countyMap[countyKey].find((data) => data.county_name === county)
        this.cityMap[cityKey] = slectedCountyData ? slectedCountyData.cities : []; // Extract cities for the selected county
      } else {
        this.cityMap[cityKey] = [];
      }
      this.form.get(cityControlPath)?.reset(); // Reset city selection
    });
  }

  // strongly typed  Mapping of the onlycities to get the vales dynamicaly declared
  initializeStateChangeCityShowHandler(
    stateControlPath: string,
    cityKey: string,
    cityControlPath: string
  ) {
    this.form.get(stateControlPath)?.valueChanges.subscribe((state: string) => {
      if (state && this.locationData) {
        // Find the state name from locationData using state code
        const stateEntry = Object.entries(this.locationData).find(
          (data: any) => data[1].state_code === state
        );
        const stateName = stateEntry ? stateEntry[0] : null; // Get state name

        if (stateName && this.locationData[stateName]) {

          this.cityMap[cityKey] = this.locationData[stateName].counties.reduce((acc: any, country: any) => acc.concat(country.cities), []); // Extract cities for the selected state
        }
      } else {
        this.cityMap[cityKey] = [];
      }
      this.form.get(cityControlPath)?.reset(); // Reset city selection
    });
  }

  clicked(event: any, i: number) {
    this.selected = i;
    if (!event.target.checked) {
      this.selected = -1;
    }
  }

  generateYearList() {
    const currentYear = new Date().getFullYear();
    for (let year = 2010; year <= currentYear; year++) {
      this.yearList.push(year);
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen; // Toggle dropdown visibility
  }

  selectYear(year: number): void {
    this.form.get('vehicle_year')?.setValue(year); // Set value in the form control
    this.isDropdownOpen = false; // Close dropdown after selection
  }

  @HostListener('window:resize', ['$event'])
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768; // Mobile breakpoint
    this.isDesktop = window.innerWidth > 768;
  }

  goToStep(step: number) {
    this.currentStep = step;
  }

  nextStep() {
    let top = this.isMobile ? document.getElementById('topMobile') : document.getElementById('topDesktop');
    if (top !== null) {
      top.scrollIntoView(true);
      top = null;
    }
    if (this.currentStep < this.steps.length - 1) {
      if (this.validateCurrentSection()) {
        this.currentStep++;
        this.steps.forEach((x: any, index) => {
          if (index === this.currentStep) {
            if (x.active) {
              this.breadcrumbService.updateActiveStep(this.currentStep);
            }
            else {
              this.breadcrumbService.setActiveStep(this.currentStep);
            }
          }
        })
        this.updateFormSection(this.currentStep);

        console.log(this.form.getRawValue());

      }
    }
  }

  // Move to the previous step
  prevStep() {
    let top = this.isMobile ? document.getElementById('topMobile') : document.getElementById('topDesktop');
    if (top !== null) {
      top.scrollIntoView(true);
      top = null;
    }

    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateFormSection(this.currentStep);
    }
    this.breadcrumbService.updateActiveStep(this.currentStep);
    // this.breadcrumbService.setActiveStep(this.currentStep);
  }

  // Update the form based on the active step
  updateFormSection(index: any) {
    // this.breadcrumbService.setActiveStep(index);
    //To get the active step heading
    this.steps.forEach((x: any) => {
      if (x['step'] === index) {
        this.currentHeading = x['label'];
        // x['currentStep']=true;
      }
      // else{
      //   x['currentStep']=false;
      // }
    })

    // if(this.isDesktop){
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    // }
  }

  getCurrentSection() {
    switch (this.currentStep) {
      case 0:
        return this.form.get('section1');
      case 1:
        return this.form.get('section2');
      case 2:
        return this.form.get('section3');
      case 3:
        return this.form.get('section4');
      case 4:
        return this.form.get('section5');
      case 5:
        return this.form.get('section6');
      case 6:
        return this.form.get('section7');
      default:
        return 0;
    }
  }

  validateCurrentSection(): Boolean {
    let currentSection: any = this.getCurrentSection();
    if (currentSection) {
      // Mark all controls as touched to trigger validation
      Object.values(currentSection.controls).forEach((control: any) => {
        control.markAsTouched();
      });

      if (currentSection.invalid) {
        currentSection.markAllAsTouched();
        this.scrollToFirstInvalidField(currentSection); // Scroll to the first invalid field


        return false;
      }

    }

    return true;
  }

  validateBreadCrumbSection(oldSection: any): Boolean {
    let value = parseInt(oldSection) + 1;
    let sectionObj: string = 'section' + value;
    let currentSection: any = this.form.get(sectionObj);

    if (currentSection.invalid) {
      currentSection.markAllAsTouched();
      this.scrollToFirstInvalidField(currentSection); // Scroll to the first invalid field
      return false;
    }
    return true;
  }

  // Scroll to the first invalid field in the current section
  scrollToFirstInvalidField(section: FormGroup): void {
    const controls = section.controls;

    // Loop through the form controls to find the first invalid field
    for (const controlName in controls) {
      const control = controls[controlName];

      if (control.invalid && control.touched) {
        const invalidField = document.querySelector(`[formControlName=${controlName}]`);
        if (invalidField) {
          invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          break; // Stop at the first invalid field
        }
      }
    }
  }

  onRadioBtnClick(value: string, formControlName: string, event: any, formSection: string): void {
    let section = this.form.get(formSection) as FormGroup;
    if (event.target.checked) {
      // this.form.get(formSection+'.'+formControlName)?.setValue(value);
      // event.target.value=true;
      // this.cdr.detectChanges();
      //  section.value.formControlName?.setValue(value);
      section.patchValue({
        [formControlName]: value,
      });
    }
    // else {
    //   section.patchValue({
    //     [formControlName]: '',
    //   });

    // }
  }

  checkForOther(label: string) {
    if (label == 'Other') {
      this.isOtherAccTypeSelected = true;
    }
    else {
      this.isOtherAccTypeSelected = false;
    }
  }

  onTimeChange(event: any, formSection: string): void {
    const section = this.form.get(formSection) as FormGroup;

    const time = event.target.value; // Get the selected time in "HH:mm" format
    if (time) {
      const [hour] = time.split(':').map(Number); // Extract the hour
      const timeZone = hour >= 12 ? 'AM0PM1' : 'AM1PM0'; // Determine AM/PM

      // Update the form controls
      section.patchValue({
        time_zone: timeZone, // Update the time zone value
      });
    }
  }

  currentStepy = signal(0);

  step() {
    return this.currentStepy();
  }

  setStep(index: number) {
    this.currentStepy.set(index);
  }

  nextStepy() {
    this.currentStepy.update(i => i + 1);
  }

  prevStepy() {
    this.currentStepy.update(i => i - 1);
  }

  onModeChange(mode: string) {
    if (mode === 'auto') {
      this.form.get('section5')?.get('conv_mode')?.setValue(null);
    } else if (mode === 'conv') {
      this.form.get('section5')?.get('auto_mode')?.setValue(null);
    }
  }

  getSelectedMode() {
    const autoMode = this.form.get('section5')?.get('auto_mode')?.value;
    const convMode = this.form.get('section5')?.get('conv_mode')?.value;
    return autoMode ? 'Autonomous Mode' : convMode ? 'Conventional Mode' : '';
  }

  generateVehString(element: { id: string, types: string, veh1: boolean, veh2: boolean }): string {
    const veh1Str = element.veh1 ? `${element.id}1V1` : `${element.id}1V0`;
    const veh2Str = element.veh2 ? `${element.id}2V1` : `${element.id}2V0`;
    return veh1Str + veh2Str;
  }

  generateYNString(element: { id: string, types: string, yes: boolean, no: boolean }): string {
    if (['B', 'C', 'D', 'E', 'F', 'G', 'I', 'J', 'K', 'L'].includes(element.id)) {
      return `${element.id}${element.id}${element.yes ? '1' : '0'}`;
    } else {
      const yesStr = `${element.id}Y${element.yes ? '1' : '0'}`;
      const noStr = `${element.id}N${element.no ? '1' : '0'}`;
      return yesStr + noStr;
    }
  }

  updateAllStrings() {
    const weatherStrings = this.ELEMENT_DATA1.map(this.generateVehString).join('');
    this.weatherString = weatherStrings;
    this.form.get('section5.weather')?.setValue(this.weatherString);

    const lightingStrings = this.ELEMENT_DATA2.map(this.generateVehString).join('');
    this.lightingString = lightingStrings;
    this.form.get('section5.lighting')?.setValue(this.lightingString);

    const rsStrings = this.ELEMENT_DATA3.map(this.generateVehString).join('');
    this.rsString = rsStrings;
    this.form.get('section5.roadway_surface')?.setValue(this.rsString);

    const rcStrings = this.ELEMENT_DATA4.map(this.generateVehString).join('');
    this.rcString = rcStrings;
    this.form.get('section5.roadway_conditions')?.setValue(this.rcString);

    const mvtStrings = this.ELEMENT_DATA5.map(this.generateVehString).join('');
    this.mvtString = mvtStrings;
    this.form.get('section5.movement')?.setValue(this.mvtString);

    const tocStrings = this.ELEMENT_DATA6.map(this.generateVehString).join('');
    this.tocString = tocStrings;
    this.form.get('section5.type_of_collision')?.setValue(this.tocString);

    const otherStrings = this.ELEMENT_DATA7.map(this.generateYNString).join('');
    this.otherString = otherStrings;
    this.form.get('section5.other')?.setValue(this.otherString);
  }

  onMatCheckboxChange(element: any, property: string, event: any, dataType: string) {
    element[property] = event.checked;
    if (property === 'yes' && event.checked) {
      element.no = false;
    } else if (property === 'no' && event.checked) {
      element.yes = false;
    }
    this.updateAllStrings();
  }


  getSection(sectionName: string): FormGroup {
    return this.form.get(sectionName) as FormGroup;
  }

  getLabel(array: { label: string, value: string }[], value: string): string {
    const item = array.find(item => item.value === value);
    return item ? item.label : '';
  }

  initializeCarStructure() {
    const shadedDamageArea = this.getSection('section2').get('Shaded_Damage_Area')?.value;
    const checkedValues = shadedDamageArea.split(',');
    this.carStructure2.forEach(row => {
      row.forEach(cell => {
        cell.isChecked = checkedValues.includes(cell.label);
      });
    });
  }

  onEdit(section: number) {
    this.breadcrumbService.updateActiveStep(section);
  }

  isCheckboxSelected(type: string, field: string, data: any[]) {
    const element = data.find(el => el.types === type);
    return element ? element[field] : false;
  }

  onSubmit() {
    this.isSubmitted = true;
    this.onSubmitErrorMessage = '';

    if (this.form?.valid) {
      let formObj = this.form.getRawValue();

      // Cognito 
      let body = new URLSearchParams();
      body.set('client_id', environment.client_id);
      body.set('client_secret', environment.client_secret);
      body.set('grant_type', 'client_credentials');
      let options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      };

      this.http.post(environment.cognito_endpoint, body.toString(), options).subscribe({
        next: (response) => {
          let data: any = response;
          const headerConfig = {
            'x-api-key': environment.x_api_key_saveData,
            'Authorization': data.access_token
          };

          // form submission
          this.http.put(environment.api_gateway_saveReportData, formObj, { headers: new HttpHeaders(headerConfig) }).subscribe({
            next: (response) => {
              let obj: any = response;
              this.isSubmitted = false;
              this.breadcrumbService.setAccidentID(obj.I_ACDNT_ID);
              this.breadcrumbService.hideBreadCrumbsComponent();
              this.breadcrumbService.setFormAsSubmitted();
              this.breadcrumbService.closeSideNav();
              this.route.navigate(['/success']);
            },
            error: (error) => {
              this.isSubmitted = false;
              this.onSubmitErrorMessage = error.error['message'];
            }
          });
        },
        error: (error) => {
          this.isSubmitted = false;
          this.onSubmitErrorMessage = 'Invalid token!';
        }
      });
    } else {
      this.isSubmitted = false;
      this.onSubmitErrorMessage = 'Please fill out all the required fields in all the form sections.';
    }
  }

  ngOnDestroy(): void {
    // Cleanup subscriptions to avoid memory leaks
    this.hourTimerSubscription?.unsubscribe();
    this.modalTimerSubscription?.unsubscribe();
  }
}